
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AgendaObject"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AgendaObjectType"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isExpired"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"typeForHuman"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"is_awaiting_status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"is_confirmed_status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"is_not_confirmed_status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"is_tour"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"object"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AcademyType"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AcademyBase"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"category"},"arguments":[],"directives":[]}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ArtFairType"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArtFair"},"directives":[]}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ArtSpaceType"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArtSpace"},"directives":[]}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ArtTripType"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArtTrip"},"directives":[]}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EventType"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Event"},"directives":[]}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExhibitionType"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExhibitionForMyAgenda"},"directives":[]}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Experience"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"media"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Media"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"destination"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DestinationBase"},"directives":[]}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistoricalSiteType"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HistoricalSite"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MiniCultivistType"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MiniCultivist"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"category"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":1297}};
    doc.loc.source = {"body":"#import \"../../academy/AcademyBase.fragment.gql\"\n#import \"../../artFair/ArtFair.fragment.gql\"\n#import \"../../artSpace/ArtSpace.fragment.gql\"\n#import \"../../artTrip/ArtTrip.fragment.gql\"\n#import \"../../destination/DestinationBase.fragment.gql\"\n#import \"../../event/Event.fragment.gql\"\n#import \"../../exhibition/ExhibitionForMyAgenda.fragment.gql\"\n#import \"../../historicalSite/HistoricalSite.fragment.gql\"\n#import \"../../miniCultivist/MiniCultivist.fragment.gql\"\n#import \"../../MediaFragment.gql\"\n\nfragment AgendaObject on AgendaObjectType {\n  id\n  isExpired\n  typeForHuman\n\n  is_awaiting_status\n  is_confirmed_status\n  is_not_confirmed_status\n  is_tour\n\n  object {\n    ... on AcademyType {\n      ...AcademyBase\n      type\n      category\n    }\n    ... on ArtFairType {\n      ...ArtFair\n    }\n    ... on ArtSpaceType {\n      ...ArtSpace\n    }\n    ... on ArtTripType {\n      ...ArtTrip\n    }\n    ... on EventType {\n      ...Event\n    }\n    ... on ExhibitionType {\n      ...ExhibitionForMyAgenda\n    }\n    ... on Experience {\n      id\n      title\n      media {\n        ...Media\n      }\n      destination {\n        ...DestinationBase\n      }\n    }\n    ... on HistoricalSiteType {\n      ...HistoricalSite\n      type\n    }\n    ... on MiniCultivistType {\n      ...MiniCultivist\n      category\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("../../academy/AcademyBase.fragment.gql").definitions));
doc.definitions = doc.definitions.concat(unique(require("../../artFair/ArtFair.fragment.gql").definitions));
doc.definitions = doc.definitions.concat(unique(require("../../artSpace/ArtSpace.fragment.gql").definitions));
doc.definitions = doc.definitions.concat(unique(require("../../artTrip/ArtTrip.fragment.gql").definitions));
doc.definitions = doc.definitions.concat(unique(require("../../destination/DestinationBase.fragment.gql").definitions));
doc.definitions = doc.definitions.concat(unique(require("../../event/Event.fragment.gql").definitions));
doc.definitions = doc.definitions.concat(unique(require("../../exhibition/ExhibitionForMyAgenda.fragment.gql").definitions));
doc.definitions = doc.definitions.concat(unique(require("../../historicalSite/HistoricalSite.fragment.gql").definitions));
doc.definitions = doc.definitions.concat(unique(require("../../miniCultivist/MiniCultivist.fragment.gql").definitions));
doc.definitions = doc.definitions.concat(unique(require("../../MediaFragment.gql").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["AgendaObject"] = oneQuery(doc, "AgendaObject");
        
